export default "__VITE_ASSET__338f3884__"